function opCreate(key, objectId, object) {
  return {
    p: [key, objectId],
    co: object,
  };
}

function opDelete(key, objectId, object) {
  return {
    p: [key, objectId],
    do: object,
  };
}

function opUpdateProperty(path, oldValue, newValue) {
  if (!Array.isArray(path)) {
    throw new Error(
      `First argument to opUpdateProperty must be the path array`
    );
  }

  return {
    p: path,
    dp: oldValue === undefined ? null : oldValue,
    cp: newValue === undefined ? null : newValue,
  };
}

function opStackCreate(index, objectId) {
  return {
    p: ["stack", index],
    cs: objectId,
  };
}

function opStackDelete(index, objectId) {
  return {
    p: ["stack", index],
    ds: objectId,
  };
}
export { opCreate, opDelete, opUpdateProperty, opStackCreate, opStackDelete };
